import { Button, Form, Popover, Select, Space } from "antd";
import { useEffect, useMemo, useState } from "react";
import { AiOutlineFilter } from "react-icons/ai";
import { DatePicker } from "../../../../../components/ui/date-picker";
import { requestStatus } from "../../../../../constants";
import CreateRequestButton from "../../../components/CreateRequestButton";
import SelectDepartmentTree from "./select-department-tree";

const { RangePicker } = DatePicker;

export interface FilterFormValues {
  dateRange?: [any, any];
  status?: string;
  department?: string;
}

interface IFilterTicketsProps {
  hideDraft?: boolean;
  filters: FilterFormValues;
  onFilter: (values: FilterFormValues) => void;
  onReset: () => void;
}

const FilterTickets = (props: IFilterTicketsProps) => {
  const { hideDraft, filters, onFilter, onReset } = props;

  const [form] = Form.useForm<FilterFormValues>();
  const [open, setOpen] = useState(false);

  const requestStatusOptions = useMemo(() => {
    const options: Array<{ label: string; value: string }> = [
      {
        label: "Đang đợi duyệt",
        value: requestStatus.submitted,
      },
      {
        label: "Đã duyệt",
        value: requestStatus.completed,
      },
      {
        label: "Từ chối",
        value: requestStatus.rejected,
      },
    ];

    if (!hideDraft) {
      options.unshift({
        label: "Đang soạn thảo",
        value: requestStatus.draft,
      });
    }

    return options;
  }, [hideDraft]);

  const handleReset = () => {
    form.resetFields();
    onReset();
  };

  const handleFilter = () => {
    const values = form.getFieldsValue();

    onFilter(values);
    setOpen(false);
  };

  const content = (
    <Form form={form} layout="vertical" style={{ width: 300 }}>
      <Form.Item label="Ngày" name="dateRange">
        <RangePicker className="ant-select-selector--h-38" style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item label="Trạng thái" name="status">
        <Select
          className="ant-select-selector--h-38"
          placeholder="Chọn trạng thái"
          allowClear
          options={requestStatusOptions}
          style={{ width: "100%" }}
        />
      </Form.Item>

      <Form.Item label="Đơn vị" name="department">
        <SelectDepartmentTree
          name="department"
          value={form.getFieldValue("department") || undefined}
          onChange={(value) => form.setFieldValue("department", value)}
          onTouched={() => {}}
          placeholder="Chọn đơn vị"
        />
      </Form.Item>

      <Form.Item
        style={{
          marginBottom: 0,
        }}
      >
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={handleReset}>Reset</Button>
          <Button type="primary" onClick={handleFilter}>
            Lọc
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );

  useEffect(() => {
    form.setFieldsValue(filters);
  }, [filters, form]);

  return (
    <Popover trigger={["click"]} placement="left" content={content} open={open} onOpenChange={setOpen}>
      <div>
        <CreateRequestButton className="!m-0" label="Bộ lọc" prefixIcon={<AiOutlineFilter />} />
      </div>
    </Popover>
  );
};

export default FilterTickets;
